const {
	findArguments,
	makeNonmathCommandNode,
	makeMathCommandNode,
} = require("../util/ParserHelpers");

const makeParser = function(mathMode) {
	const makeCommandNode = mathMode
		? makeMathCommandNode
		: makeNonmathCommandNode;
	return function(ps) {
		return makeCommandNode("phantom", findArguments(ps, 1));
	};
};

const phantomNode = {
	draw() {
		// Draw nothing. It's the phantom command... spooky!
	},
	measure(rc, fontInfo, props, node) {
		return rc.measureNode(rc, fontInfo, props, node.children[0]);
	},
	readAloud: "",
};

module.exports = {
	parsers: {
		mathCommands: {
			phantom: makeParser(true),
		},
		nonmathCommands: {
			phantom: makeParser(false),
		},
	},
	nodes: {
		phantom: phantomNode,
	},
};
